import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { usePqrInfo } from './hook';
import { PqrInfoWebProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';
import { Dialog } from '../../../../../components/general/dialog/dialog';

export const PqrWebInfo = (props: PqrInfoWebProps) => {
    const {
        formik,
        countries,
        locations,
        channelPresentsFailures,
        types,
        isColombia,
        isOpen,
        name,
        extra,
        handleClose,
    } = usePqrInfo(props);

    return (
        <>
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                pt="20px"
            >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Información PQR
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(countries)}
                        label="País"
                        name="country"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.country}
                        errors={formik.errors.country}
                        value={formik.values.country}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('country', value)
                        }
                    />
                </Grid>
                {isColombia && (
                    <Grid item xs={12} sm={6} md={4}>
                        <AutocompleteField
                            data={formatParams(locations)}
                            label="Ubicación PQR"
                            name="location"
                            size="small"
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.location}
                            errors={formik.errors.location}
                            value={formik.values.location}
                            onChangeValue={(value: any) =>
                                formik.setFieldValue('location', value)
                            }
                        />
                    </Grid>
                )}
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(channelPresentsFailures)}
                        label="Canal qué presentó falla"
                        name="channelPresentsFailure"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.channelPresentsFailure}
                        errors={formik.errors.channelPresentsFailure}
                        value={formik.values.channelPresentsFailure}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue(
                                'channelPresentsFailure',
                                value
                            )
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldSelect
                        data={types}
                        label="Tipo PQR"
                        name="type"
                        size="small"
                        touched={formik.touched.type}
                        errors={formik.errors.type}
                        value={formik.values.type as string}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FieldText
                        label="Detalle de PQR"
                        name="detail"
                        size="small"
                        required
                        rows={5}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.detail}
                        errors={formik.errors.detail}
                        value={formik.values.detail}
                        onChange={formik.handleChange}
                        tooltipWidth={650}
                        tooltipText={
                            <>
                                <h3>
                                    Con el fin de facilitar el proceso de PQR
                                    agradecemos relacionar algunos de los
                                    siguientes datos:{' '}
                                </h3>
                                <h3>
                                    <strong>Póliza: </strong>Digite el número de
                                    póliza de la cual requiere información
                                </h3>
                                <h3>
                                    <strong>Ramo: </strong>Indicar el ramo del
                                    producto del cual requiere información
                                </h3>
                                <h3>
                                    <strong>Tomador: </strong>Indicar el nombre
                                    del tomador de la póliza
                                </h3>
                                <h3>
                                    <strong>Nit y/o CC: </strong>Indicar el Nit
                                    o Cédula del tomador de la póliza
                                </h3>
                                <h3>
                                    <strong>Placa: </strong>Relacionar la placa
                                    del automotor, si su petición corresponde al
                                    ramo de Automóviles o SOAT
                                </h3>
                                <h3>
                                    <strong>Nro. Siniestro: </strong>Relacionar
                                    el número de siniestro si su petición
                                    corresponde a un proceso de indemnización
                                </h3>
                                <h3>
                                    <strong>Caso On base: </strong>Indicar el
                                    número de caso, si su petición corresponde a
                                    un proceso de indemnización
                                </h3>
                                <h3>
                                    <strong>
                                        Nro. Expediente o Servicio:{' '}
                                    </strong>
                                    Relacionar el número de servicio, si su
                                    petición corresponde a un tema de asistencia
                                </h3>
                                <h3>
                                    <strong>
                                        Radicado de Correspondencia:{' '}
                                    </strong>
                                    En este campo relacionar el número de
                                    radicado asignado por la Compañía. Ej.:
                                    2019-CR-0131152-0000-01
                                </h3>
                                <h3>
                                    <strong>Detalle PQR: </strong>
                                    Describa la petición, inconformidad,
                                    felicitación o sugerencia, en la cual se
                                    relacionen datos como: hora, fechas, sitio
                                    dónde presentó el evento, etc. La
                                    información suministrada será utilizada para
                                    el trámite.
                                </h3>
                            </>
                        }
                    />
                </Grid>
            </Grid>
            {isOpen && (
                <Dialog
                    title={name || ''}
                    open={isOpen}
                    onClose={handleClose}
                    maxWidth="sm"
                >
                    {extra}
                </Dialog>
            )}
        </>
    );
};
